import TileLayer from "ol/layer/Tile";
import OlWmtsSource from "../ol/OlWmtsSource";
import {
  attributionText,
  dfTileGrid,
  skaermkortDaempet,
} from "../util/kortforsyning";
import { WMTS } from "ol/source";

const SkaermkortDaempet = ({ layer }: { layer?: TileLayer<WMTS> }) => {
  return (
    <OlWmtsSource
      layer={layer}
      matrixSet="View1"
      layerName="topo_skaermkort_daempet"
      url={skaermkortDaempet()}
      tilegrid={dfTileGrid}
      attributionText={attributionText}
    />
  );
};

export default SkaermkortDaempet;
